import React, { useEffect } from 'react';

import { Controller } from 'react-hook-form';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage.module.scss';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    className?: string;
    value?: string;
}

export type QuickAnswerFilter =
    | 'BUDGET_GREATER_THAN_ACTUAL'
    | 'ACTUAL_GREATER_THAN_BUDGET'
    | 'ACTUAL_KPI_GREATER_THAN_REMAINING'
    | 'REMAINING_GREATER_THAN_ACTUAL_KPI';

export const quickAnswerFilterOptions: ISelectOption<QuickAnswerFilter>[] = [
    { label: 'Budget Greater Than Actual', value: 'BUDGET_GREATER_THAN_ACTUAL' },
    { label: 'Actual Greater Than Budget', value: 'ACTUAL_GREATER_THAN_BUDGET' },
    { label: 'Actual KPI Greater Than Remaining', value: 'ACTUAL_KPI_GREATER_THAN_REMAINING' },
    { label: 'Remaining Greater Than Actual KPI', value: 'REMAINING_GREATER_THAN_ACTUAL_KPI' },
];

export const QuickAnswerFilter = ({ methods, name, filtersStatusRef, handleFilters, className, value }: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }
        if (value) {
            methods?.setValue(name, value);
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [filtersStatusRef, methods, name, value]);

    const handleChange = (option: ISelectOption<string> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (filterValue) => {
        if (!filterValue) {
            return null;
        }
        return quickAnswerFilterOptions.find((item) => item.value === value) || null;
    };

    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<QuickAnswerFilter>>
                            {...field}
                            options={quickAnswerFilterOptions}
                            id={'global-filter-component-quick-answer-filter'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                            isClearable={true}
                            label={'Quick Answers'}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
